import { BvtFeatureFlags } from '@utils/bvt-feature-flags';
import withBvtFlagChecker from '@utils/bvt-feature-flags/hoc/with-bvt-flags-checker';
import { UnifiedNewIncident as SingleUiNewIncidentPage } from '../pages/single-ui/new-incident/index-lazy';
import { NewIncident as OldNewIncidentPage } from '../pages/new-incident/index-lazy';

const NewIncidentWrapper = withBvtFlagChecker(
    SingleUiNewIncidentPage, // New page if flag is ON
    OldNewIncidentPage, // Old page (Fallback) if flag is OFF
    { bvtFlagName: BvtFeatureFlags.tedig7938SingleUiRaiseIncident }
);

export default NewIncidentWrapper;
